<template>
  <v-radio-group
    :value="selectedEstate"
    class="mt-2"
    @change="$emit('change', $event)"
  >
    <v-radio
      v-for="(n, index) in estatesForRadio"
      :key="index"
      :label="`${n.text} (${n.value})`"
      :value="n.value"
    />
  </v-radio-group>
</template>

<script>
export default {
  props: {
    selectedEstate: {
      type: String,
      default: () => '',
    },

    estates: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    estatesForRadio() {
      return this.estates.map(estate => ({
        text: estate.person.name,
        value: estate.person.socialSecurityNumber,
      }));
    },
  },
};
</script>
